import { ROUTER_API } from 'app/constants/api.constant';
import axios from 'axios';
import { HereAutoSuggest, HereLookup } from './types';

const LYON = {
  longitude: 4.806397,
  latitude: 45.7613404,
  latitudeDelta: 0.0922,
  longitudeDelta: 0.0421,
};

export const hereInstance = axios.create({
  baseURL: ROUTER_API,
  timeout: 5000,
});

hereInstance.interceptors.request.use(
  request => {
    // Edit request config
    return {
      ...request,
      params: {
        ...request.params,
        token: request.headers?.common?.Authorization,
      },
    };
  },
  error => {
    return Promise.reject(error);
  },
);

export const hereAutosuggest = async (
  search: string,
  longitude = LYON.longitude,
  latitude = LYON.latitude,
): Promise<{ items: HereAutoSuggest[] }> => {
  try {
    const { data } = await hereInstance.get('/here/autosuggest', {
      params: {
        lon: longitude,
        lat: latitude,
        search,
      },
    });
    return data;
  } catch (_e) {
    return { items: [] };
  }
};

export const hereLookup = async (autosuggestId: string): Promise<HereLookup> => {
  try {
    const { data } = await hereInstance.get('/here/lookup', {
      params: {
        id: autosuggestId,
      },
    });
    return data;
  } catch (e) {
    console.error('Here/lookup error:', e);
    throw e;
  }
};
